import { render } from "./LiteratureSearchAccordion.vue?vue&type=template&id=08d39e91"
import script from "./LiteratureSearchAccordion.vue?vue&type=script&lang=js"
export * from "./LiteratureSearchAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__